import React from "react";

export default function JustAdminMessage() {


  return (
    <div className="container">
        <h4>
        Esta página es solo para administradores.
        </h4>
    </div>
  );
}